import { t } from "i18next";
import { RESERVED_PATHS } from "neetocommons/constants";
import { Facebook, Linkedin, Twitter } from "neetoicons";
import * as yup from "yup";

import {
  facebookShareLink,
  twitterShareLink,
  linkedInShareLink,
} from "./utils";

export const SOCIAL_MEDIA_OPTIONS = {
  FACEBOOK: {
    label: t("neetoMolecules.shareViaLink.socialMediaShare.facebook"),
    icon: Facebook,
    generateShareUrl: facebookShareLink,
  },
  LINKEDIN: {
    label: t("neetoMolecules.shareViaLink.socialMediaShare.linkedIn"),
    icon: Linkedin,
    generateShareUrl: linkedInShareLink,
  },
  TWITTER: {
    label: t("neetoMolecules.shareViaLink.socialMediaShare.twitter"),
    icon: Twitter,
    generateShareUrl: twitterShareLink,
  },
};

export const PATH_VALIDATION_SCHEMA = yup.object().shape({
  path: yup
    .string()
    .required(t("neetoMolecules.shareViaLink.editUrl.validationError"))
    .matches(
      /^[A-Za-z0-9]([\w/-])*$/,
      t("neetoMolecules.shareViaLink.editUrl.validationError")
    )
    .test(
      "reserved-path",
      t("neetoMolecules.shareViaLink.editUrl.reservedPathError"),
      value => !RESERVED_PATHS.includes(value?.toLowerCase())
    ),
});
